var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 14.6666V13.9998C3.33335 12.1588 4.82574 10.6666 6.66669 10.6666C8.50764 10.6666 10 12.1585 10 13.9995V14.6666M12 5.33325H16M12 9.33325H16M6.66669 3.99992C5.56212 3.99992 4.66669 4.89535 4.66669 5.99992C4.66669 7.10449 5.56212 7.99992 6.66669 7.99992C7.77126 7.99992 8.66669 7.10449 8.66669 5.99992C8.66669 4.89535 7.77126 3.99992 6.66669 3.99992ZM2.00002 1.33325H18C18.7364 1.33325 19.3334 1.93021 19.3334 2.66659V13.3333C19.3334 14.0696 18.7364 14.6666 18 14.6666H2.00002C1.26364 14.6666 0.666687 14.0696 0.666687 13.3333V2.66659C0.666687 1.93021 1.26364 1.33325 2.00002 1.33325Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcId);
export default __webpack_public_path__ + "static/media/ic_id.ee60e76d410f4737c101bb1f86cd35c3.svg";
export { ForwardRef as ReactComponent };